let cache = {};

function NewProductsService(restangular) {
    this._api = restangular.one('/Products/New');
}

NewProductsService.prototype.getProducts = function (pageSize, pageNumber, sortType) {
    const key = [pageSize, pageNumber, sortType].join('.');
    if (!(key in cache)) {
        cache[key] = this._api.get({ pageSize, pageNumber, sortType });
    }

    return cache[key].then((response) => {
        this.totalRecordCount = response.TotalRecordCount;

        return response;
    });
};

NewProductsService.prototype.invalidate = function () {
    this.totalRecordCount = null;
    cache = {};
};

module.exports = NewProductsService;



// WEBPACK FOOTER //
// ./src/shop/newproducts/newproducts.service.js